import './CategoryView.scss'
import {Button, Container} from "react-bootstrap";
import {useState} from "react";
import CategoryVideo from "./CategoryVideo";
import CategoryQuiz from "./CategoryQuiz";
import {BsChevronLeft} from "react-icons/bs";
import {useTranslation} from "react-i18next";

export default function CategoryView({ currentCat, setCurrentCat }) {
    var topic = currentCat.topics[currentCat.selected_topic]
    const { t, i18n } = useTranslation();

    const [confirmSkip, setConfirmSkip] = useState(false)

    if(currentCat.selected_topic === -1 || currentCat.selected_topic >= currentCat.topics.length) {
        for (let x = 0; x < currentCat.topics.length; x++) {
            if (!currentCat.topics[x].completed) {
                topic = currentCat.topics[x]
                //console.log('Wrong topic, choosing correct one: ' + x);
                break;
            }
        }
    }

    const questions = currentCat.topics_completed && currentCat.selected_topic <= -1 ? currentCat.questions : topic.questions

    const [course, setCourse] = useState({
        videoPlaying: topic && !topic.video_watched,
        topic: topic,
        showQuiz: currentCat.topics_completed && currentCat.selected_topic <= -1 ? true : false
    })

    const closeCategory = () => {
        setCourse({
            videoPlaying: false,
            topic: null,
            showQuiz: false
        })
        setCurrentCat(null)
    }

    const showVideo = () => {
        setCourse({...course, videoPlaying: true, showQuiz: false })
    }

    const showQuiz = () => {
        setCourse({...course, videoPlaying: false, showQuiz: true })
    }
    return <div id="category-window">
        <div className="category-window-inner">
            <header className="category-header">
                <Container className="d-flex justify-content-start gap-5 align-items-start">
                    <Button onClick={closeCategory} variant="secondary" className="d-flex align-items-center gap-2">
                        <BsChevronLeft /> {t('button.back')}
                    </Button>
                    <div>
                        <h6 className="title" dangerouslySetInnerHTML={{__html: currentCat.name}} />
                        <h1 className="title" dangerouslySetInnerHTML={{__html: currentCat.topics_completed && currentCat.selected_topic <= -1 ? 'Final Quiz' : topic.name}} />
                        <p>
                            {topic ? topic.description : t('quiz.topicDesc')}
                        </p>
                    </div>
                    {course.showQuiz && !currentCat.topics_completed ?
                        <Button onClick={showVideo} variant="info" className="d-flex align-items-center gap-2 ms-auto">
                            {t('quiz.replayVideo')}
                        </Button> : ''
                    }
                    {!course.showQuiz && topic.questions.length > 0 && <Button onClick={showQuiz} variant="secondary" className="d-flex align-items-center gap-2 ms-auto">
                        {t('quiz.goToQuiz')}
                    </Button>}
                </Container>
            </header>
            <Container>
                <section id="category-main">
                    {!course.showQuiz && !currentCat.topics_completed && <CategoryVideo course={course} setCourse={setCourse} topic={topic} paused={confirmSkip} showQuiz={showQuiz} closeCategory={closeCategory} setCurrentCat={setCurrentCat} currentCat={currentCat} />}
                    {course.showQuiz && questions.length > 0 && <CategoryQuiz setCourse={setCourse} course={course} setCurrentCat={setCurrentCat} currentCat={currentCat} isPractice={false} />}
                </section>
            </Container>
        </div>
    </div>
}